export default class DataTablesEdit {
  /*
  -For editable content add Class editable to element
  */
  constructor(config) {
    this.table_id = config['table_id'];
    this.parent_id = config['parent_id'];
    this.table_ajax = config['ajax'];
    this.table_ajax_data = config['ajax']['data'];
    this.columns = config['columns'];
    this.columns_editor = config['columns_editor'];
    this.columnDefs = config['columnDefs'];
    this.filters = config['filters'];
    this.qty_pp = config['qty_pp'];
    this.extra_but = config['extra_buttons_datatable'];
    this.is_editor = config['is_editor'];
    this.editor_ajax = config['editor_ajax'];
    this.csv_button = config['csv_button'];
    this.csv_reports = config['csv_reports'];
    this.fixedColumns = config['fixedColumns'];
    this.columns_view_filter_class = 'filter-view-columns';
    this.table_columns = this.getColumnsTable();
    this.loading = false;
    this.allDataLoaded = false;
    this.mainAjaxProcess = null;
    this.page = 1;
    if (typeof config['loadMoreDataSuccess'] != 'undefined') {
      this.loadMoreDataSuccess = config['loadMoreDataSuccess'];
    }
    if (typeof config['searching'] == 'undefined') {
      this.searching = false;
    } else {
      this.searching = config['searching'];
    }
    if (typeof config['lengthMenu'] == 'undefined') {
      this.lengthMenu = [[10, 50, 100, 1000], [10, 50, 100, 1000]];
    } else {
      this.lengthMenu = config['lengthMenu'];
    }
    if (typeof config['checkAll'] == 'undefined') {
      this.checkAll = true;
    } else {
      this.checkAll = config['checkAll'];
    }
    if (typeof config['checkAllID'] == 'undefined') {
      this.checkAllID = 'checkAll';
    } else {
      this.checkAllID = config['checkAllID'];
    }
    if (typeof config['checkAllChildsClass'] == 'undefined') {
      this.checkAllChildsClass = 'checkbox';
    } else {
      this.checkAllChildsClass = config['checkAllChildsClass'];
    }
    if (typeof config['stateSave'] == 'undefined') {
      this.stateSave = false;
      this.stateSaveName = "default";
    } else {
      this.stateSave = config['stateSave'];
      this.stateSaveName = config['stateSaveName'];
    }
    if (typeof config['buttons_extra_class'] == 'undefined') {
      this.buttons_extra_class = '';
    } else {
      this.buttons_extra_class = config['buttons_extra_class'];
    }
    if (typeof config['pageLength'] == 'undefined') {
      this.pageLength = 100;
    } else {
      this.pageLength = config['pageLength'];
    }

    if (typeof config['pagination_config'] == 'undefined') {
      this.pagination_config = 'Paginated';
    } else {
      this.pagination_config = config['pagination_config'];
    }
    if (typeof config['dom'] == 'undefined') {
      if (this.pagination_config == 'Paginated') {
        this.dom = '<"topButtons row justify-content-between"<"topButtons-left col-auto pr-0"><"col-auto"l>>rt<"datatable-footer row justify-content-between"<"col-auto"i><"col-auto"p>><"clear">';
      } else {
        this.dom = '<"topButtons row justify-content-between"<"topButtons-left col-auto pr-0"><"col-auto"li>>rt<"datatable-footer row justify-content-between"<"col-auto"p>><"clear">';
      }
    } else {
      this.dom = config['dom'];
    }
    if (typeof config['order'] == undefined) {
      this.order = [[2, "asc"]];
    } else {
      this.order = config['order'];
    }
    this.mainTable = null;

    if (typeof this.table_ajax['url'] != 'undefined') {
      this.tabAjax = this.table_ajax;
    } else {
      var ajax_url = this.table_ajax['url'];
      var type = this.table_ajax['type'];
      this.tabAjax = {
        url: ajax_url,
        "type": "POST",
        data: function (d) {
          data(d);
        },
        complete: function (response) {
          if (response.responseJSON !== undefined && response.responseJSON.success) {
            if (response.responseJSON.errmessage !== undefined) {
              errorAjax({ message: response.responseJSON.errmessage });
            }
          }
        }
      }
    }
    //this.initializeDataTable(); 
  }

  getTableId() {
    return this.table_id;
  }

  getColumnsTable() {
    var col = [];
    for (var i in this.columns) {
      if (this.columns[i]['visible'] == undefined || this.columns[i]['visible'] || this.columns[i]['colShow']) {
        col.push(this.columns[i]);
      }
    }
    this.table_columns = col;
    return col;
  }

  changeDatatableOptions(config) {
    this.table_id = config['table_id'];
    this.parent_id = config['parent_id'];
    this.table_ajax = config['ajax'];
    this.columns = config['columns'];
    this.columns_editor = config['columns_editor'];
    this.columnDefs = config['columnDefs'];
    this.filters = config['filters'];
    this.extra_but = config['extra_buttons_datatable'];
    this.is_editor = config['is_editor'];
    this.editor_ajax = config['editor_ajax'];
    this.csv_button = config['csv_button'];
    this.csv_reports = config['csv_reports'];
    this.columns_view_filter_class = 'filter-view-columns';
    this.table_columns = this.getColumnsTable();
    if (config['order'] == undefined) {
      this.order = [[2, "asc"]];
    } else {
      this.order = config['order'];
    }
    this.initializeDataTable();
  }

  initializeDataTable() {
    var id = this.table_id;
    var idParentDiv = this.parent_id;
    if (typeof this.table_ajax['url'] != 'undefined') {
      var tabAjax = this.table_ajax;
    } else {
      var ajax_url = this.table_ajax['url'];
      var type = this.table_ajax['type'];
      var tabAjax = {
        url: ajax_url,
        "type": "POST",
        data: function (d) {
          data(d);
        },
        complete: function (response) {
          if (response.responseJSON !== undefined && response.responseJSON.success) {
            if (response.responseJSON.errmessage !== undefined) {
              errorAjax({ message: response.responseJSON.errmessage });
            }
          }
        }
      }
    }
    if (typeof tabAjax.error == 'undefined') {
      tabAjax.error = function (response, jqXHR) {
        if (jqXHR == 'abort') {
          return;
        }
        errorAjax(response);
      };
    }
    var rowCallback = this.table_ajax['rowCallback'];
    var onDrawCallback = this.table_ajax['drawCallback'];
    var initComplete = this.table_ajax['initComplete'];
    var columns = this.table_columns;
    var order = this.order;
    var thisObj = this;
    var data = this.table_ajax['data'];
    /*if( $.fn.DataTable.isDataTable('#'+id)  ){
      //$('#'+id).DataTable().clear().destroy();
      //tableDatatable = $('#'+id).DataTable();
    }*/
    if (thisObj.mainTable != null) {
      thisObj.mainTable.clear();
      thisObj.mainTable.destroy();
      $('#' + id).find('thead').empty();
    }
    var mainTableConfig = {
      columns: columns,
      columnDefs: this.columnDefs,
      order: order,
      dom: thisObj.dom,
      scrollCollapse: true,
      processing: true,
      stateSave: thisObj.stateSave,
      scrollY: true,
      scrollX: true,
    };
    var mainTableConfigExtra;
    if (thisObj.pagination_config == 'Continuos') {
      mainTableConfigExtra = {
        //fixedColumns: thisObj.fixedColumns,
        paging: false,
        searching: thisObj.searching,
        info: true,
        ordering: true,
        serverSide: false,
        scrollY: 500,
        drawCallback: function (settings) {
          /*if (typeof onDrawCallback === "function") {
            onDrawCallback(settings);
          }
          onDrawMainTable(settings.json);       */

          thisObj.countCheckedCheckbox();
          shift_mark_listener($('#' + idParentDiv).find('.checkbox'));
          thisObj.initializeEditListener();
          /*$('#'+ thisObj.parent_id ).find('.dt-scroll-body').off('scroll').on('scroll', function() {
            let div = $(this).get(0);
            if (div.scrollTop + div.clientHeight >= div.scrollHeight - 5) {
              thisObj.loadMoreData();
            }
          });*/

        },/* 
        stateSaveCallback: function ( settings, data ) {
              localStorage.setItem( thisObj.stateSaveName, JSON.stringify( data ) );
        },
        stateLoadCallback: function ( ) {
          try {
            return JSON.parse( localStorage.getItem( thisObj.stateSaveName ) );
          } catch (e) {}
        },*/
        'language': {
          /*processing: "<i class='fa fa-spinner fa-spin fa-lg'></i>&emsp;Processing...",*/
          //"emptyTable": "No records found.",
          'loadingRecords': '&nbsp;',
          "lengthMenu": "_MENU_",
          "info": '_START_ to _END_ of <span class="dt-record-total"></span> entries',
          "infoEmpty": "",
          "paginate": {
            "next": '<i class="fas fa-chevron-right" title="Next" data-bs-tooltip="true"></i>',
            "previous": '<i class="fas fa-chevron-left" title="Previous" data-bs-tooltip="true"></i>'
          }
        },
        rowCallback: function (row, data) {
          rowCallback(row, data);
        },
        initComplete: function () {
          $('#' + idParentDiv).find('.topButtons-left').append($('<div class="input-group">'))
          $('#' + idParentDiv).find('div.dataTables_length select').addClass('form-control');
          //$('#'+idParentDiv).find('.topButtons-left').find('.input-group').addClass('scroll-buttons');
          thisObj.setMaxHeightMainTable(idParentDiv)
          /*var height =  thisObj.calculateMaxHeightMainTable(idParentDiv);
          $('#'+idParentDiv ).find('.dt-scroll-body').css('min-height', height+"px");
          $('#'+idParentDiv ).find('.dt-scroll-body').css('max-height', height+"px");*/

          $('#' + idParentDiv).find('.topButtons-left').find('.input-group').append(thisObj.getFilterColumns());
          $('#' + idParentDiv).find('button.save-datatable-view').on('click', function () {
            thisObj.saveDatatableColumnConfig()
          })
          if (thisObj.is_editor == true) {
            $('#' + idParentDiv).find('.topButtons-left').find('.input-group').append('<button class="btn btn-success ml-1 save" id="saveChanges" type="button" title="Save" data-bs-tooltip="true"  ><i class="far fa-save" ></i></button>');
          }
          for (var i in thisObj.extra_but) {
            var div = $('#' + idParentDiv).find(i);
            for (var k in thisObj.extra_but[i]) {
              div.append(thisObj.extra_but[i][k]);
            }
          }
          if (thisObj.csv_button == true) {
            var dd, caret;
            if (thisObj.csv_reports != null && (thisObj.csv_reports).length > 0) {
              caret = $('<button type="button" class="btn btn-outline-info dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">');
              dd = $('<div class="dropdown-menu">');
              for (var i in thisObj.csv_reports) {
                var innerHTML = thisObj.csv_reports[i]['label'];
                var onclick = thisObj.csv_reports[i]['onClick'];
                var clas = 'dropdown-item ';
                clas += (thisObj.csv_reports[i]['class'] == undefined) ? '' : thisObj.csv_reports[i]['class'];
                clas += ' csv-btn-' + id + '-' + i;
                var element = { 'type': 'button', 'innerHTML': innerHTML, 'attributes': { 'class': clas, 'data-i': i } };//  , 'onClick': onclick 
                dd.append(generateFormElement(element));
                dd.find(".csv-btn-" + id + "-" + i).off().on('click', function () {
                  let onclick = thisObj.csv_reports[$(this).data('i')]['onClick'];
                  if (typeof onclick == 'function') {
                    onclick();
                  } else {
                    thisObj.executeFunctionCall(onclick);
                  }
                })
              }
            }
            var csvButton = $('<button class="btn ' + thisObj.buttons_extra_class + ' btn-info ml-1" id="csvReport" type="button" title="Download CSV" data-bs-tooltip="true">').append('<i class="far fa-file-excel"></i>');
            $('#' + idParentDiv).find('.topButtons-left').find('.input-group')
              .append(
                $('<div class="input-group-append">').append(
                  $('<div class="btn-group">').append(csvButton)
                    .append(caret)
                    .append(dd)

                ));
            $("#csvReport").on('click', function () {
              exportTableToCSV($('#' + id), 'Data.csv');
              //getDatatablesToCSV(thisObj.mainTable, 'Data.csv');              
            })
          }
          $('#' + idParentDiv).find('div.toggle-vis').off('click.datatablesEdit').on('click.datatablesEdit', function (e) {
            e.preventDefault();
            thisObj.checkAndUncheckColumnsView($(this), idParentDiv);
            e.stopPropagation();
            return false;
          });
          $('#' + idParentDiv).find('.filter-view-columns').find('input[type="checkbox"]').off('click.datatablesEdit').on('click.datatablesEdit', function (e) {
            //e.preventDefault(); 
            $(this).closest('div.toggle-vis').click();
            $(this).prop("checked", $(this).is(":checked"));
            e.stopPropagation();
          });
          if (thisObj.checkAll) {
            var checkAllFunc = function () {
              checkAllCheckboxByClass(thisObj.checkAllID, thisObj.checkAllChildsClass);
              thisObj.countCheckedCheckbox();
            }
            $('#' + idParentDiv).find('#' + thisObj.checkAllID).off('change.checkAllFunc' + thisObj.checkAllID, checkAllFunc).on('change.checkAllFunc' + thisObj.checkAllID, checkAllFunc);
          }
          if (thisObj.editor_ajax != undefined && thisObj.editor_ajax.bulk_update == true) {
            var saveBut = $('#' + idParentDiv).find('.topButtons-left').find('#saveChanges').clone();
            $('#' + idParentDiv).find('.topButtons-left').find('#saveChanges').remove();
            $('#' + idParentDiv).find('.topButtons-left').find('.input-group').append(
              $('<div class="btn-group">').append(saveBut)
                .append($('<button type="button" class="btn btn-outline-success dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">'))
                .append($('<div class="dropdown-menu">')
                  .append(('<button class="dropdown-item bulk-save" >Batch Save</button>'))
                )
            )
          }
          $("#saveChanges").on('click', function () {
            thisObj.saveChangesDatatable();
          })
          $('#' + idParentDiv).find('.bulk-save').on('click', function () {
            var qtySelected = $('#' + thisObj.parent_id).find('input:checked.checkbox').length;
            if (qtySelected > 0) {
              thisObj.initializeBulkSaveModal($('#utilityModal'));
              openModal('utilityModal');
            } else {
              var message = { 'responseJSON': { 'message': 'Please select more than 1 item to use batch save.' } }
              errorAjax(message)
            }
          })
          if (typeof initComplete == 'function') {
            initComplete();
          }
          //thisObj.loadMoreData();
        }
      };
    } else {//paginated
      mainTableConfigExtra = {
        fixedColumns: thisObj.fixedColumns,
        drawCallback: function (settings) {
          if (typeof onDrawMainTable === "function") {
            onDrawMainTable(settings.json);
          }
          if (typeof onDrawCallback === "function") {
            onDrawCallback(settings);
          }
          thisObj.countCheckedCheckbox();
          shift_mark_listener($('#' + idParentDiv).find('.checkbox'));
          thisObj.initializeEditListener();
        },
        serverSide: true,
        ajax: tabAjax,
        stateSaveCallback: function (settings, data) {
          localStorage.setItem(thisObj.stateSaveName, JSON.stringify(data));
        },
        stateLoadCallback: function () {
          try {
            return JSON.parse(localStorage.getItem(thisObj.stateSaveName));
          } catch (e) { }
        },
        paging: true,
        pageLength: thisObj.pageLength,
        lengthMenu: thisObj.lengthMenu,
        /*scrollY: 500,
        deferRender: true,
        scroller:{
          loadingIndicator: true,
          displayBuffer: 2,
          boundaryScale: 0.9
        },*/
        'language': {
          'loadingRecords': '&nbsp;',
          "lengthMenu": "_MENU_",
          "info": "_START_ to _END_ of _TOTAL_ entries",
          "infoEmpty": "",
          "paginate": {
            "next": '<i class="fas fa-chevron-right" title="Next"></i>',
            "previous": '<i class="fas fa-chevron-left" title="Previous"></i>'
          }
        },
        rowCallback: function (row, data) {
          rowCallback(row, data);
        },
        initComplete: function () {
          $('#' + idParentDiv).find('.topButtons-left').append($('<div class="input-group">'))
          $('#' + idParentDiv).find('div.dataTables_length select').addClass('form-control');
          thisObj.setMaxHeightMainTable(idParentDiv)

          $('#' + idParentDiv).find('.topButtons-left').find('.input-group').append(thisObj.getFilterColumns());
          $('#' + idParentDiv).find('button.save-datatable-view').on('click', function () {
            thisObj.saveDatatableColumnConfig()
          })
          if (thisObj.is_editor == true) {
            $('#' + idParentDiv).find('.topButtons-left').find('.input-group').append('<button class="btn btn-success ml-1 save" id="saveChanges" type="button" title="Save" data-bs-tooltip="true"><i class="far fa-save" ></i></button>');
          }
          for (var i in thisObj.extra_but) {
            var div = $('#' + idParentDiv).find(i);
            for (var k in thisObj.extra_but[i]) {
              div.append(thisObj.extra_but[i][k]);
            }
          }
          //Make length select dropdown smaller
          let lengthSelect = $(this.api().table().container()).find('.dt-length select, .dataTables_length select');
          lengthSelect.removeClass('dt-input').addClass('custom-select');
          if (lengthSelect.closest('.topButtons').find('.form-control-sm, .custom-select-sm ').length > 0) {
            lengthSelect.addClass('custom-select-sm');
          }

          if (thisObj.csv_button == true) {
            var dd, caret;
            if (thisObj.csv_reports != null && (thisObj.csv_reports).length > 0) {
              caret = $('<button type="button" class="btn btn-outline-info dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">');
              dd = $('<div class="dropdown-menu">');
              for (var i in thisObj.csv_reports) {
                var innerHTML = thisObj.csv_reports[i]['label'];
                var onclick = thisObj.csv_reports[i]['onClick'];
                var clas = 'dropdown-item ';
                clas += (thisObj.csv_reports[i]['class'] == undefined) ? '' : thisObj.csv_reports[i]['class'];
                clas += ' csv-btn-' + id + '-' + i;
                var element = { 'type': 'button', 'innerHTML': innerHTML, 'attributes': { 'class': clas, 'data-i': i } };// 'onClick': onclick, 
                dd.append(generateFormElement(element));
                dd.find(".csv-btn-" + id + "-" + i).off().on('click', function () {
                  let onclick = thisObj.csv_reports[$(this).data('i')]['onClick'];
                  if (typeof onclick == 'function') {
                    onclick();
                  } else {
                    thisObj.executeFunctionCall(onclick);
                  }
                })
              }

            }
            var csvButton = $('<button class="btn ' + thisObj.buttons_extra_class + ' btn-info ml-1" id="csvReport-' + id + '" type="button" title="Download CSV" data-bs-tooltip="true">').append('<i class="far fa-file-excel"></i>');
            $('#' + idParentDiv).find('.topButtons-left').find('.input-group')
              .append(
                $('<div class="input-group-append">').append(
                  $('<div class="btn-group">').append(csvButton)
                    .append(caret)
                    .append(dd)
                )
              );
            $("#csvReport-" + id).on('click', function () {
              exportTableToCSV($('#' + id), 'Data.csv');
            })
          }
          $('#' + idParentDiv).find('div.toggle-vis').off('click.datatablesEdit').on('click.datatablesEdit', function (e) {
            e.preventDefault();
            thisObj.checkAndUncheckColumnsView($(this), idParentDiv);
            e.stopPropagation();
            return false;
          });
          $('#' + idParentDiv).find('.filter-view-columns').find('input[type="checkbox"]').off('click.datatablesEdit').on('click.datatablesEdit', function (e) {
            //e.preventDefault(); 
            $(this).closest('div.toggle-vis').click();
            $(this).prop("checked", $(this).is(":checked"));
            e.stopPropagation();
          });
          if (thisObj.checkAll) {
            var checkAllFunc = function () {
              checkAllCheckboxByClass(thisObj.checkAllID, thisObj.checkAllChildsClass);
              thisObj.countCheckedCheckbox();
            }
            $('#' + idParentDiv).find('#' + thisObj.checkAllID).off('change.datatablesEdit' + thisObj.checkAllID, checkAllFunc).on('change.datatablesEdit' + thisObj.checkAllID, checkAllFunc);
          }
          if (thisObj.editor_ajax != undefined && thisObj.editor_ajax.bulk_update == true) {
            var saveBut = $('#' + idParentDiv).find('.topButtons-left').find('#saveChanges').clone();
            $('#' + idParentDiv).find('.topButtons-left').find('#saveChanges').remove();
            $('#' + idParentDiv).find('.topButtons-left').find('.input-group').append(
              $('<div class="btn-group">').append(saveBut)
                .append($('<button type="button" class="btn btn-outline-success dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">'))
                .append($('<div class="dropdown-menu">')
                  .append(('<button class="dropdown-item bulk-save" >Batch Save</button>'))
                )
            )
          }
          $("#saveChanges").on('click', function () {
            thisObj.saveChangesDatatable();
          })
          $('#' + idParentDiv).find('.bulk-save').on('click', function () {
            var qtySelected = $('#' + thisObj.parent_id).find('input:checked.checkbox').length;
            if (qtySelected > 0) {
              thisObj.initializeBulkSaveModal($('#utilityModal'));
              openModal('utilityModal');
            } else {
              var message = { 'responseJSON': { 'message': 'Please select more than 1 item to use batch save.' } }
              errorAjax(message)
            }
          })
          if (typeof initComplete == 'function') {
            initComplete();
          }
        }
      }
    }

    var countCheckboxes = function () {
      thisObj.countCheckedCheckbox();
    }
    $('#' + idParentDiv).on('change', '.checkbox', function () {
      countCheckboxes();
    });

    mainTableConfig = $.extend(mainTableConfig, mainTableConfigExtra);
    thisObj.mainTable = $('#' + id).DataTable(mainTableConfig);
    if (thisObj.pagination_config == 'Continuos') {
      setTimeout(function () { thisObj.loadMoreData(); }, 1);
    }


    $('#' + this.parent_id).find('.dt-container').height("100%");
    $('#' + this.parent_id).find('.dt-scroll-body').find('tbody').addClass('bg-white');


    if (thisObj.filters != null) {
      var filters = thisObj.filters;
      $(filters.search_but).on("click", function () {
        search['type'] = $(filters.main.select_main_filter).val();
        search['value'] = $(filters.main.input_main_filter).val();
        search['advanceSearch'] = $(filters.advance.advance_search_but).data('filter');
        if (thisObj.pagination_config == 'Paginated') {
          thisObj.mainTable.settings()[0].jqXHR.abort();
          thisObj.reloadData();
        } else {
          thisObj.abortMainAjaxProcess();
          thisObj.loading = false;
          thisObj.allDataLoaded = false;
          thisObj.page = 1;
          thisObj.mainTable.clear().draw();
          thisObj.loadMoreData();
        }
      })
      $(filters.main.input_main_filter).on('keypress', function (e) {
        if (e.which === 13) {
          $(filters.search_but).click();
        }
      });
    }
  }

  abortMainAjaxProcess() {
    if (this.mainAjaxProcess != null) {
      this.mainAjaxProcess.abort();
    }
  }

  executeFunctionCall(call, scope = window) {
    const match = /^([A-Za-z_$][\w$]*)\s*\(([\s\S]*)\)\s*;?$/.exec(call.trim());

    if (!match) {
      throw new Error('Invalid function call.');
    }

    const fn = scope[match[1]];

    if (typeof fn !== 'function') {
      throw new Error(`Function "${match[1]}" was not found.`);
    }

    const args = JSON.parse(`[${match[2]}]`);

    return fn.apply(scope, args);
  }

  loadMoreData() {
    var thisObj = this;
    if (thisObj.loading || thisObj.allDataLoaded) {
      return;
    }
    if (typeof this.table_ajax['url'] != 'undefined') {
      //var tabAjax = this.table_ajax ;
    } else {
      var ajax_url = this.table_ajax['url'];
      var type = this.table_ajax['type'];
      /*var tabAjax = {
          url : ajax_url ,
          "type": "POST",
          data : function(d){
            data(d);
          },
          complete: function(response){
            if(response.responseJSON!==undefined && response.responseJSON.success){
              if(response.responseJSON.errmessage!==undefined){
                errorAjax({message:response.responseJSON.errmessage});
              }
            }
          }
      }*/
    }
    var tabAjax = this.tabAjax;

    //thisObj.mainTable.settings()[0].jqXHR.abort();
    /*if(typeof tabAjax.error == 'undefined'){
      tabAjax.error = function (response, jqXHR) {
          if (jqXHR == 'abort') {
            return;
          }
          errorAjax(response);
      };
    }*/
    const success = function (response) {
      if (typeof tabAjax.success == 'undefined') {
        tabAjax.success(response)
      }
      if (response.data.length === 0) {
        thisObj.allDataLoaded = true;
        return;
      }
      response.data.forEach(row => {
        thisObj.mainTable.row.add(row).draw(false);
      });
      //thisObj.mainTable;
      thisObj.page++;
      thisObj.loading = false;
      $("#" + thisObj.parent_id).find('span.dt-record-total').html(response.recordsTotal);
      if (typeof thisObj.loadMoreDataSuccess !== 'undefined') {
        thisObj.loadMoreDataSuccess(response);
      }
      //thisObj.setMaxHeightMainTable(thisObj.parent_id)
    };


    var onDrawCallback = tabAjax.drawCallback;

    tabAjax.success = function (response) {
      success(response);
      if (typeof onDrawMainTable === 'function') {
        onDrawMainTable(response);
      }
      if (typeof onDrawCallback === 'function') {
        onDrawCallback(response);
      }
      $('#' + thisObj.parent_id).find('.dt-scroll-body').off('scroll.datatablesEdit').on('scroll.datatablesEdit', function () {
        let div = $(this).get(0);
        if (div.scrollTop + div.clientHeight >= div.scrollHeight - 5) {
          thisObj.loadMoreData();
        }
      });
      if ($('#' + thisObj.parent_id).find('.dt-scroll-body').height() > $('#' + thisObj.parent_id).find('tbody').height()
        && response.data.length >= thisObj.pageLength) {
        thisObj.loadMoreData();
      }

    }

    const error = function (response, jqXHR) {
      if (response.statusText == "abort" || jqXHR == 'abort') {
        return;
      }
      errorAjax(response);
      tabAjax.error;
    };

    tabAjax.error = function (response) {
      thisObj.loading = false;
      error(response);
    }
    tabAjax.data = {}
    tabAjax.data = thisObj.table_ajax_data(tabAjax.data);
    const qtyPP = thisObj.qty_pp ?? 50;
    tabAjax.data.start = (thisObj.page - 1) * qtyPP;
    tabAjax.data.length = qtyPP;
    if (thisObj.mainTable != null) {
      thisObj.mainTable.order();
    }
    thisObj.loading = true;

    if (thisObj.page == 1 && thisObj.mainTable != null) {
      thisObj.mainTable.processing(true);
      $('#' + thisObj.table_id).find('tbody .dt-empty').hide();
    }
    thisObj.mainAjaxProcess = $.ajax(tabAjax)
      .done(function (result) {
        thisObj.mainAjaxProcess = null;
        thisObj.mainTable.processing(false);
        $('#' + thisObj.table_id).find(' tbody .dt-empty').show();
      });;
  }

  initializeEditListener() {
    $("#" + this.parent_id).find("input.editable, select.editable").off("change.datatablesEdit").on("change.datatablesEdit", function () {
      $(this).addClass('edited');
    })
  }

  initializeBulkSaveModal(modalElement) {
    var attributes = {};
    var thisObj = this;
    var k = 0;
    for (var i in this.columns) {
      if (this.columns[i]['bulk_update'] == true) {
        attributes[k++] = { 'value': this.columns[i]['data'], 'text': this.columns[i]['title'] };
      }
    }
    $(modalElement).find('.modal-title').html('Bulk Update');
    //$(modalElement).find('.modal-dialog').addClass('modal-lg');
    var modalBody = $(modalElement).find('.modal-body');
    var footer = $(modalElement).find('.modal-footer');
    var qtySelected = $('#' + this.parent_id).find('input:checked.checkbox').length;
    footer.empty();
    footer.append($('<button class="btn btn-outline-success save-bulk-button" >').append('<i class="far fa-save "></i> <span class="font-weight-bold">Save Rows Selected:</span> <span class="rows-selected">' + qtySelected + '</span>'));
    footer.append($('<button type="button" data-dismiss="modal" class="btn btn-danger ">').append('Close'));
    modalBody.empty();
    $(modalElement).addClass('bulk-update-body');
    var data = {}
    var d = 0;
    $('#' + this.parent_id).find('input:checked.checkbox').each(function (index, element) {
      data[d++] = { 'id': $(element).val() };
    })
    modalBody
      .append($('<div class="row justify-content-center header mb-1">')
        .append($('<div class="col-5">')
          .append('<span>Attribute</span>')
        )
        .append($('<div class="col-5">')
          .append('<span>Value</span>')
        )
        .append($('<div class="col-1">')
          .append('<buton class = "btn text-success fa fa-plus add-bulk-update-row" title="Add Batch Change" data-bs-tooltip="true"></button>')
        )
      )
    $(modalElement).find('.save-bulk-button').data('data', data);

    $(modalElement).find('.add-bulk-update-row').off('click.datatablesEdit').on('click.datatablesEdit', function () {
      $(modalElement).find('.modal-body').append($('<div class="row justify-content-center mb-1">')
        .append($('<div class="col-5">')
          .append(getSelectHTML('', attributes, { 'class': 'custom-select att-select-bulk' }))
        )
        .append($('<div class="col-5">')
          .append('<input class="form-control att-value-bulk">')
        )
        .append($('<div class="col-1">')
          .append('<buton class = "btn text-danger fa fa-trash remove-bulk-update-row" title="Remove Attribute" data-bs-tooltip="true"></button>')
        )
      )

      $(modalElement).find('.remove-bulk-update-row').off('click.datatablesEdit').on('click.datatablesEdit', function () {
        $(this).closest('div.row').remove();
      })
      $(modalElement).find('.att-select-bulk').off('change').on('change', function () {
        var key = $(this).val();
        var newElem;
        for (var i in thisObj.columns) {
          if (thisObj.columns[i]['data'] == key) {
            newElem = thisObj.columns[i]['element_render'];
            break;
          }
        }
        var input = $(this).closest('.row').find('.att-value-bulk');
        var parentDivInput = input.closest('div');
        newElem['attributes']['class'] = 'form-control att-value-bulk';
        newElem['default_value'] = ""; //input.val();
        newElem = generateFormElement(newElem);
        parentDivInput.append(newElem);
        input.remove();
      }).change();
    });
    $(modalElement).find('.save-bulk-button').off('click.datatablesEdit').on('click.datatablesEdit', function () {
      $(this).find('i').addClass('fa-spin');
      thisObj.saveBulkChangesDatatable(this);
      $(this).find('i').removeClass('fa-spin');
    })
    $(modalElement).find('.add-bulk-update-row').click();

  }

  calculateMaxHeighScrollY(contenido_height, datatableDIV) {
    $(datatableDIV).height(contenido_height);
    var scrollHeight = contenido_height - ($('#' + this.parent_id).find(".topButtons").outerHeight(true) ?? 0) - $('#' + this.parent_id).find('.dt-scroll-head').outerHeight(true) - $('.datatable-footer').outerHeight(true);
    $('#' + this.table_id).closest('.dt-scroll-body').css('max-height', (scrollHeight) + 'px').css('min-height', (scrollHeight) + 'px');
  }

  saveBulkChangesDatatable(element) {
    var data = {};
    var d = 0;
    var thisObj = this;
    var elmntData = $(element).data('data');
    for (var k in elmntData) {
      $(element).closest('.bulk-update-body').find('.att-select-bulk').each(function (i, e) {
        var value = $(e).closest('.row').find('.att-value-bulk').val();
        if (value.length > 0) {
          var key = $(e).val();
          var dat = { 'id': elmntData[k]['id'], [key]: value };
          data[d++] = dat;
        }
      });
    }
    if (Object.keys(data).length > 0) {
      var callback = function () {
        $(thisObj.filters.search_but).click();
        var check = function () {
          for (var k in elmntData) {
            $('#' + thisObj.table_id).find('input[type="checkbox"][value="' + elmntData[k]['id'] + '"].checkbox').prop('checked', true);
          }
          thisObj.countCheckedCheckbox()
        }
        thisObj.reloadData(check);
        closeModal($(element).closest('.modal').attr('id'));
      }
      var aux = [];
      var i = 0;
      var maxPost = 100;
      for (var k in data) {
        aux[i] = data[k];
        i++;
        if (maxPost <= i) {
          var next = parseInt(k) + 1;
          if (data[next] == undefined) {
            thisObj.saveChangesDatatableAJAX(aux, callback, true);
          } else {
            thisObj.saveChangesDatatableAJAX(aux, null, false);
          }
          i = 0;
          aux = [];
        }
      }
      if (i > 0) {
        thisObj.saveChangesDatatableAJAX(aux, callback, true);
      }
    }
    $(element).find('i').removeClass('fa-spin');
  }

  countCheckedCheckbox(elementSearch = $('#' + this.parent_id), elementNumber = $('#' + this.parent_id).find('#' + this.checkAllID).closest('div').find('.form-check-label'), elementPrincipalCheckbox = $('#' + this.parent_id).find('#' + this.checkAllID)) {
    var numChecked = $(elementSearch).find('input:checked.' + this.checkAllChildsClass).length;
    var total = $(elementSearch).find('input.' + this.checkAllChildsClass).length;
    if (numChecked == total && total > 0) {
      $(elementPrincipalCheckbox).prop('indeterminate', false);
      $(elementPrincipalCheckbox).prop('checked', true);
    } else if (numChecked > 0) {
      $(elementPrincipalCheckbox).prop('indeterminate', true);
    } else {
      numChecked = '';
      $(elementPrincipalCheckbox).prop('indeterminate', false);
      $(elementPrincipalCheckbox).prop('checked', false);
    }
    $(elementNumber).html(numChecked);
  }

  checkAndUncheckColumnsView(element, idParentDiv) {
    // Get the column API object
    var column = this.mainTable.column($(element).attr('data-column'));
    // Toggle the visibility
    var visitbility = !column.visible();
    column.visible(visitbility);
    var inputCheckbox = $('#' + idParentDiv).find('.filter-view-columns').find('input[data-id="' + $(element).attr('data-id') + '"]');
    inputCheckbox.prop("checked", visitbility);
    $('#' + idParentDiv).find('button.save-datatable-view').removeClass('d-none');
    this.initializeEditListener();
  }

  saveDatatableColumnConfig(data) {
    var parent = $('#' + this.parent_id);
    var columns_view_filter = parent.find('.' + this.columns_view_filter_class);
    var data = {};
    var i = 0;
    columns_view_filter.find('input[type="checkbox"]').each(function (i, e) {
      if ($(e).is(":checked")) {
        data[i] = {
          code: $(e).data('id'),
        };
        i++;
      }
    })
    this.saveDatatableColumnConfigAJAX(data);
  }

  saveDatatableColumnConfigAJAX(data) {
    var idParentDiv = this.parent_id;
    var thisObj = this;
    $.ajax({
      type: this.columns_editor.type,
      url: this.columns_editor.url,
      data: { "data": data, 'route': thisObj.table_ajax['url'] },
      dataSrc: '',
      error: function (response) {
        errorAjax(response);
      },
      success: function (response) {
        if (response.success) {
          $('#' + idParentDiv).find('button.save-datatable-view').addClass('d-none');
          successAjax("View Updated Succesfully.");
          if (thisObj.filters != null && typeof thisObj.filters.search_but != 'undefined') {
            $(thisObj.filters.search_but).click();
          }
        }
      },
    });
  }

  getFilterColumns() {
    var columns = this.table_columns;
    var checked = '';
    var col = '';
    col = $('<div class="btn-group ' + this.columns_view_filter_class + '" >')
      .append($('<button class="btn ' + this.buttons_extra_class + ' btn-outline-dark  dropdown-toggle" data-toggle="dropdown">')
        .append('Col<span class="d-none d-md-inline">umns</span> <span class="caret"></span>'))
      .append($('<div class="dropdown-menu column-menu pull-right overflow-auto" style="max-height: 50vh">'))
      .append($('<button type="button" class="btn ' + this.buttons_extra_class + ' btn-outline-success d-none save-datatable-view" title="Save View" data-bs-tooltip="true">')
        .append('Save <i class="fas fa-eye"></i>'));
    var col_menu = col.find('.dropdown-menu');
    var filter = false;
    for (var i in columns) {
      if (columns[i]['colShow']) {
        if (columns[i]['data'] != 'checkbox') {
          if (columns[i]['visible']) {
            checked = 'checked';
          } else {
            checked = '';
          }
          var dataId = typeof (columns[i]['data']) !== "string"
            ? JSON.stringify(columns[i]['data'])
            : columns[i]['data'];
          dataId = dataId.replaceAll('"', "'");
          col_menu.append($('<div class="dropdown-item toggle-vis" data-column="' + i + '" data-id="' + dataId + '" >')
            .append($('<label class="label-info label col-xs-12">')
              .append('<input type="checkbox"  ' + checked + ' data-id="' + dataId + '"> ' + columns[i]['title'] + '')
            )
          )
        }
        filter = true;
      }
    }
    if (filter == false) {
      col = '';
    }
    return col;
  }

  saveChangesDatatable() {
    var data = {};
    var i = 0;
    $('.edited').each(function (index, element) {
      var mainId = $(element).closest('tr').find('.checkbox').val();
      var key = $(element).data('id');
      var value = $(element).val();
      data[i++] = {
        'id': mainId,
        [key]: value,
      }
    })
    if (i > 0) {
      this.saveChangesDatatableAJAX(data);
    }
  }

  saveChangesDatatableAJAX(data, callback = null, successMessage = true, async = true) {
    var thisObj = this;
    $.ajax({
      type: this.editor_ajax.type,
      url: this.editor_ajax.url,
      data: { "data": data },
      async: async,
      dataSrc: '',
      error: function (response) {
        errorAjax(response);
      },
      success: function (response) {
        if (successMessage) {
          successAjax("Updated Succesfully.");
        }
        $('.edited').removeClass('edited');
        if (callback == null) { } else {
          callback();
        }
      },
    });
  }

  reloadData(funct = function () { }, userPagingRes = true) {
    if (this.pagination_config == 'Paginated') {
      this.mainTable.settings()[0].jqXHR.abort();
      this.mainTable.clear();
      this.mainTable.ajax.reload(funct, userPagingRes);
      //thisObj.setMaxHeightMainTable(idParentDiv)
    } else {
      this.abortMainAjaxProcess();
      this.loading = false;
      this.allDataLoaded = false;
      this.page = 1;
      this.mainTable.clear().draw();
      this.loadMoreData();
    }
  }

  calculateMaxHeightMainTable(idParentDiv) {
    var height = $('#' + idParentDiv).find('.dt-container').outerHeight(true) - $('#' + idParentDiv).find('.dt-scroll-head').outerHeight(true) - $('#' + idParentDiv).find('.topButtons').outerHeight(true) - $('#' + idParentDiv).find('.datatable-footer').outerHeight(true);
    return height;
  }

  setMaxHeightMainTable(idParentDiv) {
    let height = this.calculateMaxHeightMainTable(idParentDiv);
    $('#' + idParentDiv).find('.dt-scroll-body').css('min-height', height + "px");
    $('#' + idParentDiv).find('.dt-scroll-body').css('max-height', height + "px");
  }

  calculateMaxHeightMainContent() {
    height = $(document).height() - $('#navbar').outerHeight(true) - $('#footer').outerHeight(true) - $('#filters').outerHeight(true) - $(document).find('.my-1').outerHeight(true);
    return height;
  }
}